import { AppTabKey } from "@quote/types";
import { StateCreator } from "zustand";

import { AppState } from "./types";

export const createAppState: StateCreator<
  AppState,
  [["zustand/devtools", never]]
> = (set) => ({
  defaultTabKey: AppTabKey.HOTEL_GOLF,

  appActions: {
    setDefaultTabKey: (key: AppTabKey) => {
      set({ defaultTabKey: key }, undefined, "app/setDefaultTabKey");
    },
  },

  appUtils: {},
});
